// extracted by mini-css-extract-plugin
export default {"whiteLabeledToggle":"src-signer-app-signer-signature-document-accessible-document-toggle-module__whiteLabeledToggle--2ykEc"};